import { AxiosResponse } from "axios"
import ConnectApi from "../../baseService"
import { TApiResponse } from "../../TApiResponse"
import {
  TAGCRoziKasimaKosokuryoHokokuListGetReq,
  TAGCRoziKasimaKosokuryoHokokuListGetRes,
} from "./TAGCRoziKasima"

/**
 * AGCロジ鹿島に対するAPIリクエスト用サービス
 *
 * @export
 * @class AGCRoziKasimaKosokuryoHokokuService
 * @extends {ConnectApi}
 */
export default class AGCRoziKasimaKosokuryoHokokuService extends ConnectApi {
  /**
   * 一覧取得
   *
   * @param {TAGCRoziKasimaKosokuryoHokokuListGetReq} params
   * @param {(param: TApiResponse<TAGCRoziKasimaKosokuryoHokokuListGetRes[]>) => any} resolve
   * @param {(param: TApiResponse<TAGCRoziKasimaKosokuryoHokokuListGetRes[]>) => any} reject
   * @memberof AGCRoziKasimaKosokuryoHokokuService
   */
  getList = async (params: TAGCRoziKasimaKosokuryoHokokuListGetReq) => {
    try {
      const res: AxiosResponse<
        TApiResponse<TAGCRoziKasimaKosokuryoHokokuListGetRes[]>
      > = await this.getInner(`/billing/agckosokuryohokoku`, params)
      return res.data
    } catch (err) {
      throw err
    }
  }
}
